import { render } from "./StatusActionsHistory.vue?vue&type=template&id=c3700fe6&scoped=true&ts=true"
import script from "./StatusActionsHistory.vue?vue&type=script&lang=ts"
export * from "./StatusActionsHistory.vue?vue&type=script&lang=ts"

import "./StatusActionsHistory.vue?vue&type=style&index=0&id=c3700fe6&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3700fe6"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QIcon,QTable,QTr,QTh,QTd});
